import {
  PROMO_CHANGE_VALUE,
  PROMO_CHANGE_VALUES,
} from '@shared/store/constants/mutationTypes';
const mutations = {
  [PROMO_CHANGE_VALUE]: (state, payload) => {
    const {
      field,
      value,
    } = payload;

    state[field] = value;
  },
  [PROMO_CHANGE_VALUES]: (state, payload) => {
    const {
      changes,
    } = payload;
    changes.forEach((change) => {
      const {
        field,
        value,
      } = change;
      state[field] = value;
    });
  },
};
export default mutations;
